import React, { FC }                                    from 'react';
import { ENVIRONMENT_LABEL }                            from '../../../../constants/SystemEnums';
import { ScriptLoaderWithVisualBug, VendorLoaderProps } from './ScriptLoaderWithVisualBug';

const defaultProps: VendorLoaderProps = {
	id: null
}

const GoogleAnalytics: FC<VendorLoaderProps> = ( { id, ...props } ) => {
	
	const initScript = () => {
		
		let script = document.createElement( 'script' );
		
		script.async = true;
		script.id    = `ga-coval-${ ENVIRONMENT_LABEL }-${ id }`;
		script.src   = `https://www.googletagmanager.com/gtag/js?id=${ id }`;
		
		if( !document.getElementById( script.id ) ){
			
			//@ts-ignore
			window.dataLayer = window.dataLayer || [];
			
			function gtag( ...args: any[] ){
				
				//@ts-ignore
				window.dataLayer.push( args );
			}
			
			gtag( 'js', new Date() );
			
			gtag( 'config', props.id );
		}
		
	};
	
	return ( id ? <ScriptLoaderWithVisualBug onLoad={ initScript } { ...props }/> : null );
}

GoogleAnalytics.defaultProps = defaultProps;

export { GoogleAnalytics }
